import { Cookie } from './cookie.ts';

export const matchesCohort = (value: string | null, ...cohorts: string[]): boolean => {
  if (!value) {
    return false;
  }

  return cohorts.includes(value);
};

export type CookieInput = string | { cookieName: string; cookieText: string | undefined };

/**
 * Prüft, ob der gegebene Wert (`value`) in der Liste der angegebenen Cohorts (`cohorts`) enthalten ist.
 * Gibt `true` zurück, wenn der Wert gefunden wurde, andernfalls `false`.
 *
 * @param value - Der zu prüfende Wert (z.B. ein Cohort-Name oder -Wert), kann auch `null` sein.
 * @param cohorts - Eine Liste von Cohort-Namen oder -Werten, gegen die geprüft wird.
 * @returns `true`, wenn `value` in `cohorts` enthalten ist, sonst `false`.
 */
export const matchesCohortFromCookie = (
  cookieInput: CookieInput,
  ...cohorts: string[]
): boolean => {
  let cookie = undefined;

  if (typeof cookieInput === 'string') {
    cookie = new Cookie(cookieInput);
  } else if (cookieInput && typeof cookieInput === 'object') {
    cookie = new Cookie(cookieInput.cookieName, cookieInput.cookieText);
  }

  return cohorts.includes(cookie?.value ?? '');
};

/**
 * The following cohort class is only a concept and should not be used!
 */
export class Cohort {
  private name: string;
  private values: Set<string>;

  constructor(input: string | { name: string; values: string[] }, ...values: string[]) {
    if (typeof input === 'string') {
      this.name = input;
      this.values = new Set(values);
    } else if (input && typeof input === 'object') {
      this.name = input.name;
      this.values = new Set(input.values);
    } else {
      this.name = '';
      this.values = new Set();
    }
  }

  has(value: string): boolean {
    return this.values.has(value);
  }

  hasAny(...values: string[]): boolean {
    return values.some(v => this.values.has(v));
  }

  hasAll(...values: string[]): boolean {
    return values.every(v => this.values.has(v));
  }
}

// const cohort = new Cohort('sk-AB-adsetup', '1', '2', '3');
// cohort.has('1'); // true
// cohort.has('4'); // false
// cohort.hasAny('1', '2'); // true
// cohort.hasAny('1', '4'); // true
// cohort.hasAny('4', '5'); // false
// cohort.hasAll('1', '2'); // true
// cohort.hasAll('1', '4'); // false
